import { Component } from 'react';
import { Box, Chip, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import { faGitlab, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'; // faFacebookSquare, faTwitter

export default class Contacts extends Component {
  getItems() {
    return [
      {
        name: 'email',
        icon: faEnvelope,
        link: 'mailto:clara.al.martins@gmail.com',
      },
      {
        name: 'github',
        icon: faGithub,
        link: 'https://github.com/LeKinaSa',
      },
      {
        name: 'gitlab',
        icon: faGitlab,
        link: 'https://gitlab.com/LeKinaSa',
      },
      {
        name: 'linkedin',
        icon: faLinkedin,
        link: 'https://www.linkedin.com/in/clara-a-martins/',
      },
      {
        name: 'cv',
        icon: faFileLines,
        link: '/cv',
      },
      // {
      //   name: 'twitter',
      //   icon: faTwitter,
      //   link: 'https://twitter.com/c_lekinasa',
      // },
      // {
      //   name: 'facebook',
      //   icon: faFacebookSquare,
      //   link: 'https://www.facebook.com/profile.php?id=100007492729480',
      // },
    ];
  }

  render() {
    const items = this.getItems();
    let itemsList = [];
    items.forEach((item, index) => {
      let classNameStr = 'transparent contact ' + item.name;
      let label = <FontAwesomeIcon className='icon' icon={item.icon} size='xl' />;
      itemsList.push(
        <Grid key={index} size='grow' >
          <Chip className={classNameStr} label={label}
            component='a' href={item.link} clickable />
        </Grid>
      );
    });

    return (
      <Box className='contacts center-block'>
        <Grid container sx={{ width: '100%' }} >
          {itemsList}
        </Grid>
      </Box>
    );
  }
}
